import React from 'react';
import Artintegrated from 'views/Artintegrated';

const DesktopAppPage = () => {
  return <Artintegrated />;
};

export default DesktopAppPage;
